module.exports = {
  detailOfTheBill: 'Detail of the bill', // 单据明细
  EggStockInDetails: 'Egg Stock In Details', // 种蛋入库明细
  purchaseOrder: 'Purchase Order', // 采购订单
  purchaseOrderDetails: 'Purchase Order Details', // 采购订单明细
  openOrders: 'Open orders', // 未清订单
  orderDetails: 'Order details', // 订单明细
  outgoingDetails: 'Outgoing details', // 出库明细
  inboundDetails: 'Inbound Details', // 入库明细
  transferDetails: 'Transfer details', // 调拨明细
  eggCollectionDetails: 'Egg collection details', // 收蛋明细
  regular: 'Regular', // 常规
  price: 'Price', // 身价
  entryDetails: 'Entry details', // 入舍明细
  feedingDetails: 'Feeding details', // 饲喂明细
  immunizationAndMedicationDetails: 'Immunization and medication details', // 免疫及用药明细
  mortality: 'Mortality', // 死淘
  eggProduction: 'Egg Production', // 蛋品入库
  cull: 'Cull', // 出栏
  selectCulling: 'Select culling', // 选淘登记
  selectCullingDetails: 'Select culling details', // 选淘登记明细
  registrationDetailsOfSlaughterhouse: 'Registration details of slaughterhouse', // 出栏登记明细
  transferOutDetails: 'Transfer out details', // 转出明细
  transferInDetails: 'Transfer in details', // 转入明细
  breakdownOfHerd: 'Breakdown of herd', // 分群明细
  testCollectionDetails: 'Test collection details', // 试验领用明细
  weightBreakdown: 'Weight breakdown', // 体重明细
  weeklyPlanDetail: 'Weekly Plan Detail', // 周计划明细
  deadAmoyDetail: 'Dead Amoy Detail', // 死淘明细
  egg: 'Egg', // 照蛋
  dropTray: 'Drop tray', // 落盘
  hatching: 'Hatching', // 出雏
  feedingStandardDetails: 'Feeding standard details', // 饲喂标准明细
  vaccinationStandardDetails: 'Vaccination standard details', // 免疫标准明细
  antibodyStandardDetails: 'Antibody standard details', // 抗体标准明细
  environmentalStandards: 'Environmental standards', // 环境标准
  rearingPeriod: 'Rearing period', // 饲养期
  feedingStandards: 'Feeding standards', // 饲喂标准
  immunizationStandards: 'Immunization standards', // 免疫标准
  medicationStandard: 'Medication standard', // 用药标准
  incubationDetails: 'Incubation details', // 上孵明细
  recheckDetails: 'Recheck details', // 复检明细
  detailsOfEggsAndFallingPlates: 'Details of eggs and falling plates', // 照蛋及落盘明细
  hatchingDetails: 'Hatching details', // 出雏明细
  lowConsumptionDetails: 'Low consumption details',//低耗明细
  breedingStandard: 'Breeding standard',//养殖标准
  securityDeposit: 'Security Deposit',//保证金
  materialSettlementPrice: 'Material settlement price',//物资结算价格
  fees: 'Fees',//费用
  subsidy: 'Subsidy',//补贴
  recoveryPrice: 'Recovery price',//回收价格
  recoverySettlement: 'Recovery settlement',//回收结算
  remarks: 'Remarks',//备注
  priceList: 'Price list',//价格清单
  feedDetail: 'Feed Detail',//饲料明细
  detailsOfTheMove: 'Details of the move',//动保明细
  materialDetails: 'Material Details',//物料明细
  contractPriceListDetails: 'Contract price list details',//合同价格清单详情
  symptoms: 'Symptoms',//症状
  visceralAnatomy: 'Visceral anatomy',//脏器解剖
  treatmentOptions: 'Treatment options',//治疗方案
  inspectionItem: 'Inspection item',//巡检项
  consumptionInformation: 'Consumption information',//耗用信息
  subsidyItem: 'Subsidy item',//补贴项
  expenseItem: 'Expense item',//费用项
  penalty: 'Penalty',//惩罚项
  settlement: 'Settlement',//结算
  consumptionSummary: 'Consumption summary',//耗用汇总
  columnSummary: 'Column summary',//出栏汇总
  marginRecord: 'Margin record',//保证金记录
  materialConversionDetails: 'Material conversion details',//物料转换明细
  eggStorage: 'Egg storage (feathering)',//蛋品入库(换羽)
  receipt: 'Receipt',//领用
  requisitionStatistics: 'Requisition statistics'//领用统计
}